import DeliveryOptionsContainer from './deliveryOptions/DeliveryOptions.container';

const DeliveryOptions = () => <DeliveryOptionsContainer />;

export default DeliveryOptions;
